/**
 * طرح‌های میز از پنل — GET /v1/tables ([[applyTables]]).
 *
 * مثلِ پیکربندیِ از راه دور (`remote.ts`): پس از رندر و بی انتظار، و هیچ‌وقت نمی‌شکند. تا
 * نرسیده، همان هفده طرحِ ساخته‌شده با نام و رنگِ خودشان‌اند؛ شهری که ادمین ساخته تا آن لحظه
 * ایوان دیده می‌شود و با رسیدنِ فهرست همان‌جا جایش را می‌گیرد.
 */
import { applyTables, type TableItem } from "../game/carpet";
import { httpUrl } from "./config";

export async function loadTables(): Promise<void> {
  try {
    const r = await fetch(httpUrl("/v1/tables"));
    if (!r.ok) return;
    const body = (await r.json()) as { items?: TableItem[] };
    if (Array.isArray(body.items)) applyTables(body.items, httpUrl(""));
  } catch {
    // شبکه نبود یا سرورِ کهنه: همان طرح‌های ساخته‌شده
  }
}
